import { Icon, styled } from '@mui/material';

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { BaseComponentPropsType } from '../../type';
import React from 'react';

const Container = styled('div')(({ theme }) => ({
  '.arrow-text': {
    fontSize: 14,
    fontWeight: 600,
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    color: theme.palette.primary.main,
    margin: `5px 0`,
    ':hover': {
      cursor: 'pointer',
    },
  },
}));

interface ArrowLinkProps {
  text: string;
  url?: string;
  Link?: BaseComponentPropsType['LinkComponent'];
  onTextClick?: () => void;
}

const IconComponent = (
  <Icon sx={(theme) => ({ color: theme.palette.primary.main })}>
    <ArrowRightAltIcon />
  </Icon>
);

export const ArrowLink = ({ text, url, Link, onTextClick }: ArrowLinkProps) => {
  const handleClick = () => {
    if (onTextClick) onTextClick();
  };
  return (
    <Container>
      {Link && url ? (
        <Link to={url} style={{ textDecoration: 'none' }} className="arrow-text">
          {text}
          {IconComponent}
        </Link>
      ) : (
        <div onClick={handleClick} className="arrow-text">
          {text}
          {IconComponent}
        </div>
      )}
    </Container>
  );
};
